import styled from 'styled-components';

import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';

import { OwnAiTitle } from '../../../OwnAI/components/Title';

export const TitleStyles = styled(OwnAiTitle)`
  margin: 8px auto;
`;

export const SubtitleStyles = styled(OnboardingSubtitle)`
  margin: 0 auto 40px !important;
`;

export const OptionsContainerStyles = styled.div`
  width: 100%;
`;
